import React, { useEffect, useState } from 'react';

const ExportModal = ({ isOpen, onClose, onExport }) => {
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const handleExport = () => {
        if (fromDate && toDate) {
            onExport(fromDate, toDate);
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isOpen]);

    return (
        isOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
                    <h2 className="text-lg font-bold mb-4">Export Report</h2>
                    <p className="text-sm text-gray-600 mb-4">
                        Please select a date range to export the report. The report will be downloaded as a CSV file containing transactions within the selected date range.
                    </p>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1 text-start" htmlFor="fromDate">
                            From Date
                        </label>
                        <input
                            type="date"
                            id="fromDate"
                            className="w-full border rounded-md p-2"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1 text-start" htmlFor="toDate">
                            To Date
                        </label>
                        <input
                            type="date"
                            id="toDate"
                            className="w-full border rounded-md p-2"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                    </div>
                    <div className="flex justify-end items-center">
                        <button
                            className="py-2 px-4 bg-gray-300 text-gray-800 rounded-md mr-2"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            className={`py-2 px-4 text-white rounded-md ${fromDate && toDate ? 'bg-primary' : 'bg-gray-300 cursor-not-allowed'
                                }`}
                            onClick={handleExport}
                            disabled={!fromDate || !toDate}
                        >
                            Export
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default ExportModal;
